//
// These are the lists associated with the roles available in the system.
// If any action (update, delete, insert) is performed in system, should be performed on all these lists of roles
//

export const roles = {
    1: 'ADMIN_USER',
    2: 'DISTRICT_LEVEL_USER',
    3: 'M&E_MANAGER',
    4: 'TEMP_LIMITED_ROLE'
};

export const roleWithIds = {
    ADMIN_USER: 1,
    DISTRICT_LEVEL_USER: 2,
    'M&E_MANAGER': 3,
    TEMP_LIMITED_ROLE: 4
};


export const allowedRoles = {
    ADMIN_USER: true,
    DISTRICT_LEVEL_USER: false,
    "M&E_MANAGER": false,
    TEMP_LIMITED_ROLE: false
};

